import { useQuery } from '@tanstack/solid-query'
import { itemTypeId } from '~/config'
import { getServiceClient } from '~/lib/api'

export function usePurchaseStats() {
  return useQuery(() => ({
    queryKey: ['purchase-stats', { itemTypeId: itemTypeId }],
    queryFn: async () => {
      const { client, userId } = await getServiceClient()
      return await client
        .get(`store/users/${userId}/item-type/${itemTypeId}/purchase-stats`)
        .json<{
          stats:
            | null
            | {
                purchase_type: 'coin' | 'gem'
                total_price: number
                total_quantity: number
              }[]
        }>()
    },
  }))
}

export function useUserPurchaseStats() {
  return useQuery(() => ({
    queryKey: ['own-purchase-stats', { itemTypeId: itemTypeId }],
    queryFn: async () => {
      const { client, userId } = await getServiceClient()
      return await client
        .get(`store/users/${userId}/item-type/${itemTypeId}/own-purchase-stats`)
        .json<{
          stats:
            | null
            | {
                purchase_type: 'coin' | 'gem'
                total_price: number
                total_quantity: number
              }[]
        }>()
    },
  }))
}
